import { render, staticRenderFns } from "./ExtraChips.vue?vue&type=template&id=b7b9dc46&scoped=true"
import script from "./ExtraChips.vue?vue&type=script&lang=js"
export * from "./ExtraChips.vue?vue&type=script&lang=js"
import style0 from "./ExtraChips.vue?vue&type=style&index=0&id=b7b9dc46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b9dc46",
  null
  
)

export default component.exports